export default __webpack_public_path__ + "static/media/midasi_entry_en_pc@2x.94a2c894.png";